var map = {
	"./app_store_download.svg": 4475,
	"./arrow-icons.svg": 5538,
	"./bike.jpg": 1796,
	"./canter.jpg": 9727,
	"./dubai_phone_display_1.webp": 7490,
	"./dubai_phone_display_2.webp": 1282,
	"./dubai_phone_display_3.webp": 2111,
	"./phone_skin.png": 4068,
	"./pickup.jpg": 9760,
	"./play_store_download.svg": 8933,
	"./spot_cities__bd.svg": 6143,
	"./spot_cities__uae.png": 5992,
	"./spot_cities__uae.svg": 6111,
	"./spot_feature.jpg": 6617
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2159;